/**
 * @class ControlFilterSwitch
 *
 * creates a filter switcher like the iPad to show only one filter while drilling down nested data
 *
 */
import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ControlSwitch from './controlSwitch';

/**
 * @method filterFromEntity - this just turns an entity name into it's `filter` name.
 */
const filterNameFromEntity = entity => {
  const camelCase = str => str.substr(0, 1).toLowerCase() + str.substr(1);
  let result = "".concat(camelCase(entity), "s");
  const len = entity.length;
  if (entity.substr(len - 1, len) === 'y') {
    result = "".concat(result.substr(0, len - 1), "ies");
  } else if (entity.substr(len - 1, len) === 's') {
    result = "".concat(camelCase(entity), "es");
  }
  return result;
};

/**
 *  Return an array of filter object names
 */
const valuesFromFilters = function valuesFromFilters(filterName, filterControlObject) {
  let field = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'name';
  const titleValues = filterControlObject.titleValues;
  if (typeof titleValues === 'function') {
    return titleValues();
  }
  if (titleValues !== undefined) {
    return titleValues;
  }
  let result = [];
  let filterNames = filterName;
  if (!_.isArray(filterName)) {
    filterNames = [filterName];
  }
  filterNames.forEach(fname => {
    const vals = filterControlObject.filters[fname];
    if (vals && vals.length > 0) {
      if (vals[0][field] !== undefined) {
        const sortedVals = vals.sort((a, b) => {
          // In the case of a collision, sort by the name, alphabetically
          if (a.sortOrder === b.sortOrder) {
            return a[field] > b[field] ? 1 : -1;
          }
          return a.sortOrder - b.sortOrder;
        });
        result = result.concat(_.pluck(sortedVals, field));
      }
    }
  });
  if (result.length === 0) {
    result = ['Any'];
  }
  return result;
};
export default class ControlFilterSwitch extends Component {
  constructor(props) {
    super(props);
    this.handleBack = this.handleBack.bind(this);
  }
  handleBack() {
    // switch control back to top level.
    this.controlSwitch.switchControl();
  }
  createControl(filterControlObject) {
    const control = filterControlObject.control,
      entity = filterControlObject.entity,
      label = filterControlObject.label;
    const filterName = filterControlObject.filterName ? filterControlObject.filterName : filterNameFromEntity(entity);
    return this.createControlObject(label, filterName, control, filterControlObject);
  }
  createControlObject(name, filterName, control, filterControlObject) {
    let id = filterName;
    if (_.isArray(filterName)) {
      id = filterName.join('_');
    }
    return {
      name,
      id,
      control,
      values: valuesFromFilters.bind(this, filterName, filterControlObject)
    };
  }

  /* @method render - renders this component.
   *   Assumes props.filterControls come in
   *   in an array of objects:
   *   [{
   *      label: <label>,
   *      control: <controlComponent>
   *      filters: <array of values already selected for the filter>
   *    }, ...]
   */
  render() {
    const _this$props = this.props,
      className = _this$props.className,
      filterControls = _this$props.filterControls;
    const controls = [];
    filterControls.forEach(incomingFilterControlObject => {
      const filterControlObject = incomingFilterControlObject;
      if (filterControlObject.filters === undefined) {
        filterControlObject.filters = {};
      }
      controls.push(this.createControl(filterControlObject));
    });
    return /*#__PURE__*/React.createElement(ControlSwitch, {
      className: "t-cfs ".concat(className),
      controls: controls,
      ref: input => {
        this.controlSwitch = input;
      },
      onBack: this.handleBack
    });
  }
}
ControlFilterSwitch.propTypes = {
  className: PropTypes.string,
  filterControls: PropTypes.arrayOf(PropTypes.shape({
    filters: PropTypes.shape({})
  })).isRequired
};
ControlFilterSwitch.defaultProps = {
  className: ''
};